import { useState, useEffect } from 'react'
import Dropdown from '../../utils/Dropdown'
import { FaBars, FaTimes } from 'react-icons/fa'; 
import aeds from "../../assets/images/AEDS.png"; 
import { useNavigate } from 'react-router-dom';
import { ReactComponent as Mail } from "../../assets/svg/mail.svg";
import { ReactComponent as Phone } from "../../assets/svg/phone.svg";
import { ReactComponent as Loc } from "../../assets/svg/loc.svg";
export default function Header() {
  
  const handleClick = () => {
    if (window.location.pathname !== '/') {
      // Navigate to the homepage
      navigate('/');
      // Once the page is loaded, scroll to the Contact Us section
      setTimeout(() => {
        const contactSection = document.getElementById('contactus');
        if (contactSection) {
          contactSection.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      // If on the homepage, scroll directly to the Contact Us section
      const contactSection = document.getElementById('contact-us');
      if (contactSection) {
        contactSection.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };
  const [top, setTop] = useState(true);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const scrollHandler = () => {
    window.pageYOffset > 10 ? setTop(false) : setTop(true)
  }

  useEffect(() => {
    scrollHandler()
    window.addEventListener('scroll', scrollHandler)
    return () => window.removeEventListener('scroll', scrollHandler)
  }, [top])

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  }

  return (
    <header className={`fixed w-full z-30 md:bg-opacity-90 transition duration-300 ease-in-out ${!top ? 'bg-white backdrop-blur-sm shadow-lg' : ''}`}>

      <div className='h-6 bg-[#006DC4]'>
      <ul className='flex  justify-evenly'>
              <div className="flex space-x-3 justify-between">
                <Loc  className='h-6 w-auto'       />
                <li className="text-white text-left w-full font-medium">
                  Soliman, Nabeul
                </li>
              </div>
              <div className="flex space-x-3 justify-between">
                <Phone className='h-6 w-auto'      />
                <li className="text-white text-left w-full font-medium">
                  +216 12 345 678
                </li>
              </div>
              <div className="flex space-x-3 justify-between">
                <Mail className='h-6 w-auto' />
                <li className="text-white text-left w-full font-medium">
                  gireausol@gmail.com
                </li>
              </div>
            </ul>
      </div>
      <div className="relative w-[80%] mx-auto px-5 py-3 sm:px-6">
        <div className="flex items-center justify-between h-16 md:h-20">

          {/* Logo */}
          <div className="shrink-0 flex space-x-4 items-center mr-8">
            <img onClick={()=>{navigate("/")}} src={aeds} alt='aeds'  width={120} height={120}/>
            <img
              src={!top ? "assets/images/logoscroll.png" : "assets/images/initialLogo.png"}
              width={60}
              height={60}
              alt="Logo"
            />
          </div>

          {/* Hamburger menu for mobile */}
          <div className="md:hidden flex items-center">
            <button onClick={toggleMobileMenu} className="text-2xl focus:outline-none">
              {mobileMenuOpen ? <FaTimes /> : <FaBars />} {/* Show close icon when menu is open */}
            </button>
          </div>

          {/* Desktop navigation */}
          <nav className="hidden lg:flex lg:grow overflow-visible">
            <ul className="flex grow justify-end items-center ">
              
              <li className=''>
                <a href="/observatoire" className={  ` text-nowrap w-fit font-medium ${!top ? 'text-gray-600' : 'text-white'} hover:text-gray-700 px-5 py-3 flex items-center transition duration-150 ease-in-out`}>Observatoire</a>
              </li>
              <li className=''>
                <a href="/donnessolution" className={  ` text-nowrap w-fit font-medium ${!top ? 'text-gray-600' : 'text-white'} hover:text-gray-700 px-5 py-3 flex items-center transition duration-150 ease-in-out`}>Données scientifiques</a>
              </li>
              
              {/* <li className=''>
              <a href="/events"  className={ ` text-nowrap w-fit font-medium ${!top ? 'text-gray-600' : 'text-white'} hover:text-gray-700 px-5 py-3 flex items-center transition duration-150 ease-in-out`}>Evénements</a>
              </li> */}
              <li className=''>
                <a href="/apropos"  className={ ` text-nowrap w-fit font-medium ${!top ? 'text-gray-600' : 'text-white'} hover:text-gray-700 px-5 py-3 flex items-center transition duration-150 ease-in-out`}>À propos</a>
              </li>
              <li className=''>
              <button onClick={handleClick} className={ ` text-nowrap w-fit font-medium ${!top ? 'text-gray-600' : 'text-white'} hover:text-gray-700 px-5 py-3 flex items-center transition duration-150 ease-in-out`}>Contact Us</button>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      <div className={`fixed inset-0 bg-black bg-opacity-50 z-40 transition-all duration-300 ${mobileMenuOpen ? 'block' : 'hidden'}`} onClick={toggleMobileMenu}>
        <div className="fixed top-0 right-0 h-full w-64 bg-white shadow-lg z-50 p-5" onClick={(e) => e.stopPropagation()}>
          <nav className="flex flex-col space-y-4">
            <a href="/" className="font-medium text-gray-600 hover:text-gray-700">Page d'acceuil</a>
            <a href="/Observatoire" className="font-medium text-gray-600 hover:text-gray-700">Observatoire</a>
            <a href="/donnes-solution" className="font-medium text-gray-600 hover:text-gray-700">Données scientifiques</a>
            {/* <a href="/events" className="font-medium text-gray-600 hover:text-gray-700">Evénements</a> */}

            
          </nav>
        </div>
      </div>

    </header>
  )
}
